import { trans } from "@mongez/localization";
import { lessonOffersAtom } from "../atoms/lesson-offers.atom";

export function OffersTabWithCounter() {
  const { offers, isLoading } = lessonOffersAtom.useValue();
  const count = offers.length;

  const baseLabel = trans("offers.title");

  if (isLoading) {
    return (
      <div className="flex items-center gap-2">
        <span>{baseLabel}</span>
        <div className="h-4 w-4 animate-spin rounded-full border-2 border-gray-300 border-t-primary-600 dark:border-gray-600 dark:border-t-primary-400"></div>
      </div>
    );
  }

  if (count > 0) {
    return (
      <div className="flex items-center gap-2">
        <span>{baseLabel}</span>
        <span className="inline-flex items-center justify-center rounded-full bg-green-100 px-2 py-0.5 text-xs font-medium text-green-800 dark:bg-green-950/50 dark:text-green-300">
          {count}
        </span>
      </div>
    );
  }

  return <span>{baseLabel}</span>;
}
